import { PaginationInfo } from './../../../_models/pagination-info';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CourseService } from '../../../_services/course.service';
import { GlobalService } from '../../../_services/global.service';

@Component({
  selector: 'iq-central-front-end-select-course',
  templateUrl: './select-course.component.html',
  styleUrls: ['./select-course.component.scss'],
})
export class SelectCourseComponent implements OnInit {
  sub: Subscription = new Subscription();
  p: number = 1;
  selectedCourses: any[] = [];
  courses;
  filteredCourses: any;
  paginationInfo: PaginationInfo;
  isCheck: boolean;
  constructor(
    private _course: CourseService,
    private router: Router,
    private _global: GlobalService,
    private route: ActivatedRoute
  ) {
    this.isCheck = false;
  }

  ngOnInit(): void {
    this.getAllCourses();
  }
  getAllCourses() {
    this._global.showSpinner();
    this.sub.add(
      this._course.getAllCompanyCourses().subscribe({
        next: (res) => {
          this._global.hideSpinner();
          this.courses = this.filteredCourses = res['responseResult']?.courses;
        },
      })
    );
  }

  checkUncheckAll() {
    for (var i = 0; i < this.courses.length; i++) {
      this.courses[i].isSelected = this.isCheck;
    }
    this.getCheckedItemList();
  }

  isAllSelected() {
    this.isCheck = this.courses.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }

  getCheckedItemList() {
    this.selectedCourses = [];
    for (let i = 0; i < this.courses.length; i++) {
      if (this.courses[i].isSelected)
        this.selectedCourses.push(this.courses[i].code);
    }

    // this.selectedCourses = JSON.stringify(this.checkedCategoryList);
  }

  selectDeselectCourses(courseCode) {
    this.selectedCourses.includes(courseCode)
      ? (this.selectedCourses = this.selectedCourses.filter(
          (code) => code != courseCode
        ))
      : this.selectedCourses.push(courseCode);
  }

  continue() {
    this._course.setCourseData({
      courseCodes: this.selectedCourses,
    });
    this.router.navigate(['/assignCourse/selectParticipant']);
  }

  navigatePage(page) {
    this._course.getAllCompanyCourses().subscribe({
      next: (res) => {
        this.courses = res['responseResult'].courses;
        this.paginationInfo = res['responseResult'].paginationInfo;
      },
    });
  }

  filter(query: string) {
    this.courses = query
      ? this.filteredCourses.filter((c) =>
          c.title.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredCourses;
  }

  sortByName() {
    this.courses.sort((a, b) => {
      if (a.title < b.title) return -1;
      else if (a.title > b.title) return 1;
      else return 0;
    });
  }
}
